import React, {useEffect, useRef, useState} from 'react';
import MerchantTable from './merchant_table';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import {Button, Divider, Input, notification} from 'antd';
import {SearchOutlined} from '@ant-design/icons';
import serviceHelper from '../../../helpers/functions/service.helper';
import merchantService from "../../../services/ewallet_integration/merchant.service";
import MerchantService from "../../../services/ewallet_integration/merchant.service";
import moment from "moment";
import globalHelper from "../../../helpers/functions/global.helper";
import CreateMerchantModal from "./new_merchant_modal";
import {useSelector} from "react-redux";

const MerchantLayout = ({ default_filter }) => {
    const componentRef = useRef();
    const [exportLoading, setExportLoading] = useState(false);
    const authRedux = useSelector(state => state?.auth);

    const [timer, setTimer] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [state, setState] = useState({
        merchants: []
    });
    const [createMerchantModal, setCreateMerchantModal] = useState(false);
    const [filter, setFilter] = useState({
        merchant_id : default_filter?.merchant_id,
    });

    const fetchFilterItem = async () => {
        const merchantResponse = await merchantService?.merchants();
        setState(state => ({...state, merchants : merchantResponse?.data?.merchants}));
    }
    
    // for changing filter
    const changeFilter = (key, value) => {
        let generate_filter = default_filter;
        generate_filter[key] = value;
        const queryString = serviceHelper?.queryString(generate_filter);
        window.history.replaceState({}, '', `${window.location.pathname}?${queryString}`);
    }


    const exportExcel = async () => {
        setExportLoading(true);
        const { merchant_id, } = filter;
        const response = await MerchantService?.payment_report({
            merchant_id,
        });
        const {  rows } = response?.data?.payments;

        const exportRows = rows.map((v, index) => {
            const { activity_status,from_wallet, created_at, transaction_no,melon_amount } = v;

            return {
                "No": index + 1,
                "Name": from_wallet?.customer?.name || "-",
                "Wallet": from_wallet?.name || "-",
                "Phone No.": `${from_wallet?.customer.mobile_dial_no}${from_wallet?.customer.phone_no}` || "-",
                "Transaction No.": transaction_no || "-",
                "Amount": melon_amount != null ? Number(melon_amount).toFixed(2) : "0.00",
                "Status": activity_status?.name || "-",
                "Date": moment(created_at)?.isValid() ? moment(created_at).format("DD MMM YYYY HH:mm") : "",
            };
        });

        globalHelper.exportToExcel({
            data : exportRows,
            name : `merchant_report_${moment()?.format("YYYYMMDD")}`,
        });

        setExportLoading(false);
        // setState(state => ({...state, generate_loading : false, }));
    }

    const doneTyping = async (input) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setFilter(filter => ({ ...filter, search: input, }));
            changeFilter('search', input);
        }, 300);
        setTimer(newTimer);
    }

    useEffect(() => {
        fetchFilterItem();
    }, []);


    const handleCreateMerchant = async (values) => {
        // Call your API here
        const payload = {
            ...values,
            country_code: 'MY',
            account_id: authRedux.auth.account_id,
        };

        await merchantService.createMerchant(payload)
            .then((response) => {
                notification?.success({
                    message : 'merchant create successfully',
                })
                setRefresh(true);
            })
            .catch((error) => {
                notification?.error({
                    message : 'Failed to create merchant. Please try again.',
                })
            })
            .finally(() => {
            });

    };


    return (
        <>
            <div className='mobile-padding-12'>
                <div style={{marginBottom: 24, textAlign:'start'}}>
                    <PageHeaderComponent title={'Merchants'} />
                </div>
                <div className='filter-panel'>

                    <div style={{ marginBottom: '12px' }}>
                        <Input
                            onChange={(e) => doneTyping(e.target.value)}
                            name="search"
                            defaultValue={filter?.search}
                            prefix={<SearchOutlined style={{color: 'var(--secondary-text-color)'}}/>}
                            placeholder='Search'
                            style={{minWidth: '100%',}}
                            allowClear
                            // {...(errors?.find(x => x?.type === 'search_length') && ({ status : 'warning', }))}
                        />
                    </div>
                    <div style={{display:'flex', alignItems:'center', }}>
                        <div style={{textAlign:'start',}}>
                        </div>
                        <div style={{marginLeft:'auto'}}>
                            {/*<Button loading={exportLoading} onClick={() => exportExcel()}>*/}
                            {/*    Export*/}
                            {/*</Button>*/}
                            <Button type="primary" onClick={() => setCreateMerchantModal(true)} >
                                New Merchant
                            </Button>
                        </div>
                    </div>
                </div>
                <Divider />
                <div ref={componentRef} style={{marginTop:12,}}>
                    <MerchantTable filter={filter} refresh={refresh} setRefresh={setRefresh} />
                </div>

                <CreateMerchantModal visible={createMerchantModal} onClose={() => setCreateMerchantModal(false)}  onCreate={handleCreateMerchant}/>
            </div>
        </>
    );
}

export default MerchantLayout;